import { useSelector } from 'react-redux';
import { getCurrentUserRule } from 'store/users/usersSelectors';

const useRule = () => {
  const rule = useSelector(getCurrentUserRule);
  return rule;
};

export default useRule;
